export interface ICandidateAdvisor {
  id: number;
  status: string;
}

export class CandidateAdvisor {
  public id: number;
  public status: string;

  constructor(data: ICandidateAdvisor) {
    this.id = data.id;
    this.status = data.status;
  }
}
